import { ANSWER_SELECT, UPDATE_QUESTION, RECEIVE_QUESTIONS, RESTART } from '../actions';
import getQueryParameterByName from 'utils/getQueryParameterByName';

const overrideIndexes = getQueryParameterByName('questions');
const questionsToComplete = overrideIndexes ? overrideIndexes.split(',').length : 5;
const overridePersonaId = getQueryParameterByName('persona');
const answers = overridePersonaId ? [overridePersonaId] : [];

export const quiz = (state = { current: 0, prev: null, answers, pool: [], beauty: [], xpoolIndex: 0, questionsToComplete }, action) => {// selected will be array or maybe the q/a should be object with answer object?
  switch (action.type) {
    case ANSWER_SELECT:
      const { index } = action;
      return {
        ...state,
        answers: [...state.answers, index]
      }
    case UPDATE_QUESTION:
      const { current, prev } = action;
      return {
        ...state,
        current,
        prev
      }
    case RECEIVE_QUESTIONS:
      const { pool, beauty } = action;
      return {
        ...state,
        pool,
        beauty
      }
    case RESTART:
      const { poolIndex } = action;
      return {
        ...state,
        current: 0,
        prev: null,
        answers: [],
        poolIndex
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quiz.js